import { defineMessages } from 'react-intl';

export const messages: {
	webSearchSpotlightHeadline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchSpotlightBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchPreferenceSpotlightHeadline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchPreferenceSpotlightBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchSpotlightDismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchSpotlightDone: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webSearchSpotlightManageDefaults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	webSearchSpotlightHeadline: {
		id: 'post-office.rovo-chat.web-search-spotlight.headline',
		defaultMessage: 'Web search is now on by default',
		description: 'Headline for web search spotlight onboarding',
	},
	webSearchSpotlightBody: {
		id: 'post-office.rovo-chat.web-search-spotlight.body',
		defaultMessage:
			"We're running an experiment to improve Rovo. For some users, web search is now on by default—you can turn it off any time.",
		description: 'Body text for web search spotlight onboarding',
	},
	webSearchPreferenceSpotlightHeadline: {
		id: 'post-office.rovo-chat.web-search-preference-spotlight.headline',
		defaultMessage: 'Web search is on',
		description: 'Headline for web search preference spotlight onboarding',
	},
	webSearchPreferenceSpotlightBody: {
		id: 'post-office.rovo-chat.web-search-preference-spotlight.body',
		defaultMessage: 'Web search is now on by default. You can turn it off anytime.',
		description: 'Body text for web search preference spotlight onboarding',
	},
	webSearchSpotlightDismiss: {
		id: 'post-office.rovo-chat.web-search-spotlight.dismiss',
		defaultMessage: 'Turn off default web search',
		description: 'Dismiss button label for web search spotlight',
	},
	webSearchSpotlightDone: {
		id: 'post-office.rovo-chat.web-search-spotlight.done',
		defaultMessage: 'Done',
		description: 'Primary action button label for web search spotlight',
	},
	webSearchSpotlightManageDefaults: {
		id: 'post-office.rovo-chat.web-search-spotlight.manage-defaults',
		defaultMessage: 'Manage my defaults',
		description: 'Secondary action button label for web search spotlight',
	},
});
